<script>
import options from './FormInputTextField.options'
export default options
</script>

<template>
    <div class="Form__Element FormTextbox" :class="{ValidationRequired: isRequired}">
        <label :for="fieldName" class="Form__Element__Caption" >
            {{ label }}

        </label>

        <template v-if="tooltipText">
            <TooltipComponent :tooltipText="tooltipText" />
        </template>

        <input class="FormTextbox__Input"
            :disabled="disabled ? disabled : readOnly" 
            :value="modelValue" 
            :autocomplete="autocomplete"
            :class="{'validation-error': isValidationError}"
            :id="fieldName" 
            :type="type"
            :aria-describedby="`${fieldName}__desc`" 
            :aria-invalid="isValidationError"
            :placeholder="placeholder"
            :maxlength="maxlength"
            :required="isRequired ? true : false"
            @input="(event) => {$emit('update:modelValue', event.target.value); onChangeCallback(event)}"
            @blur="onChangeCallback"
            />
            
            <div aria-live="assertive">
                <p class="kb-forms Form__Element__ValidationError" 
                    role="alert" 
                    v-if="isValidationError">
                    {{ errorMessageLabel }}
                </p>
            </div>

            <p class="kb-form__input-helptext" v-if="helpMessageLabel" >
                {{ helpMessageLabel }}
            </p>

    </div>
</template>